import { z } from 'zod'

import { Pagination } from '@/types/app/request'
import { Machine } from '@/types/machines/machine'
import { Client } from '@/types/park/client'

export const Refund = z.object({
    reason: z.string().optional(),
    amount: z.string().optional(),
    previous_credit: z.string().optional(),
})

export type Refund = z.infer<typeof Refund>

/** Dispute returned for the disputes endpoints. */
export const Dispute = z.object({
    id: z.number().positive(),
    date_time: z.string(),
    client: Client.optional(),
    machine: Machine.optional(),
    refund: Refund.optional(),
    total: z.string().optional(),
})

export type Dispute = z.infer<typeof Dispute>

export const DisputesRequest = Pagination.extend({
    results: Dispute.array(),
})

export type DisputesRequest = z.infer<typeof DisputesRequest>
